import { en, type Dict } from "./en";

export type MessageKey = keyof Dict;

// Locales are registered here; the active one is chosen once at startup.
const dictionaries: Record<string, Dict> = { en };
let active: Dict = en;

export function setLocale(locale: string): void {
  active = dictionaries[locale] ?? en;
}

/** Looks up a string by key and substitutes `{name}` parameters. */
export function t(key: MessageKey, params?: Record<string, string | number>): string {
  const s = active[key] ?? en[key];
  if (!params) return s;
  return s.replace(/\{(\w+)\}/g, (m, k: string) => (k in params ? String(params[k]) : m));
}
